import React from 'react';
import { Grid } from '@mui/material';
import FilterCheckboxList from 'internal/shared/FilterCheckboxList';

export default function ProgramTypes({
    options,
    programTypes,
    onProgramTypesChanged,
}: {
    options: string[];
    programTypes: string[];
    onProgramTypesChanged: (x: string) => void;
}) {
    return (
        <Grid>
            <FilterCheckboxList
                options={options}
                selectedOptions={programTypes}
                onChange={(x) => onProgramTypesChanged(x)}
            />
        </Grid>
    );
}
